var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotPattern4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 133,
    viewBox: "0 0 123 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 2.08901C4.17801 3.24318 3.24318 4.17801 2.08901 4.17801C0.93483 4.17801 0 3.24318 0 2.08901C0 0.93483 0.93483 0 2.08901 0C3.24318 0 4.17801 0.93483 4.17801 2.08901Z",
    fill: "#82BB98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 12.5343C4.17801 13.6885 3.24318 14.6233 2.08901 14.6233C0.93483 14.6233 0 13.6885 0 12.5343C0 11.3801 0.93483 10.4453 2.08901 10.4453C3.24318 10.4453 4.17801 11.3801 4.17801 12.5343Z",
    fill: "#82BB98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 12.5343C15.3186 13.6885 14.3838 14.6233 13.2296 14.6233C12.0755 14.6233 11.1406 13.6885 11.1406 12.5343C11.1406 11.3801 12.0755 10.4453 13.2296 10.4453C14.3838 10.4453 15.3186 11.3801 15.3186 12.5343Z",
    fill: "#82BB98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 12.5343C25.7639 13.6885 24.8291 14.6233 23.6749 14.6233C22.5208 14.6233 21.5859 13.6885 21.5859 12.5343C21.5859 11.3801 22.5208 10.4453 23.6749 10.4453C24.8291 10.4453 25.7639 11.3801 25.7639 12.5343Z",
    fill: "#82BB98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 12.5343C36.2093 13.6885 35.2744 14.6233 34.1203 14.6233C32.9661 14.6233 32.0312 13.6885 32.0312 12.5343C32.0312 11.3801 32.9661 10.4453 34.1203 10.4453C35.2744 10.4453 36.2093 11.3801 36.2093 12.5343Z",
    fill: "#82BB98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 12.5343C47.3499 13.6885 46.4151 14.6233 45.2609 14.6233C44.1067 14.6233 43.1719 13.6885 43.1719 12.5343C43.1719 11.3801 44.1067 10.4453 45.2609 10.4453C46.4151 10.4453 47.3499 11.3801 47.3499 12.5343Z",
    fill: "#82BB98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 12.5343C57.7952 13.6885 56.8604 14.6233 55.7062 14.6233C54.552 14.6233 53.6172 13.6885 53.6172 12.5343C53.6172 11.3801 54.552 10.4453 55.7062 10.4453C56.8604 10.4453 57.7952 11.3801 57.7952 12.5343Z",
    fill: "#82BB98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 12.5343C68.9378 13.6885 68.0029 14.6233 66.8488 14.6233C65.6946 14.6233 64.7598 13.6885 64.7598 12.5343C64.7598 11.3801 65.6946 10.4453 66.8488 10.4453C68.0029 10.4453 68.9378 11.3801 68.9378 12.5343Z",
    fill: "#82BB98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 12.5343C79.3811 13.6885 78.4463 14.6233 77.2921 14.6233C76.138 14.6233 75.2031 13.6885 75.2031 12.5343C75.2031 11.3801 76.138 10.4453 77.2921 10.4453C78.4463 10.4453 79.3811 11.3801 79.3811 12.5343Z",
    fill: "#82BB98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 12.5343C90.5237 13.6885 89.5889 14.6233 88.4347 14.6233C87.2805 14.6233 86.3457 13.6885 86.3457 12.5343C86.3457 11.3801 87.2805 10.4453 88.4347 10.4453C89.5889 10.4453 90.5237 11.3801 90.5237 12.5343Z",
    fill: "#82BB98"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 12.5343C100.969 13.6885 100.034 14.6233 98.88 14.6233C97.7258 14.6233 96.791 13.6885 96.791 12.5343C96.791 11.3801 97.7258 10.4453 98.88 10.4453C100.034 10.4453 100.969 11.3801 100.969 12.5343Z",
    fill: "#82BB98"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 12.5343C111.414 13.6885 110.48 14.6233 109.325 14.6233C108.171 14.6233 107.236 13.6885 107.236 12.5343C107.236 11.3801 108.171 10.4453 109.325 10.4453C110.48 10.4453 111.414 11.3801 111.414 12.5343Z",
    fill: "#82BB98"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 12.5343C122.555 13.6885 121.62 14.6233 120.466 14.6233C119.312 14.6233 118.377 13.6885 118.377 12.5343C118.377 11.3801 119.312 10.4453 120.466 10.4453C121.62 10.4453 122.555 11.3801 122.555 12.5343Z",
    fill: "#82BB98"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 23.6749C4.17801 24.8291 3.24318 25.7639 2.08901 25.7639C0.93483 25.7639 0 24.8291 0 23.6749C0 22.5208 0.93483 21.5859 2.08901 21.5859C3.24318 21.5859 4.17801 22.5208 4.17801 23.6749Z",
    fill: "#82BB98"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 23.6749C15.3186 24.8291 14.3838 25.7639 13.2296 25.7639C12.0755 25.7639 11.1406 24.8291 11.1406 23.6749C11.1406 22.5208 12.0755 21.5859 13.2296 21.5859C14.3838 21.5859 15.3186 22.5208 15.3186 23.6749Z",
    fill: "#82BB98"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 23.6749C25.7639 24.8291 24.8291 25.7639 23.6749 25.7639C22.5208 25.7639 21.5859 24.8291 21.5859 23.6749C21.5859 22.5208 22.5208 21.5859 23.6749 21.5859C24.8291 21.5859 25.7639 22.5208 25.7639 23.6749Z",
    fill: "#82BB98"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 23.6749C36.2093 24.8291 35.2744 25.7639 34.1203 25.7639C32.9661 25.7639 32.0312 24.8291 32.0312 23.6749C32.0312 22.5208 32.9661 21.5859 34.1203 21.5859C35.2744 21.5859 36.2093 22.5208 36.2093 23.6749Z",
    fill: "#82BB98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 23.6749C47.3499 24.8291 46.4151 25.7639 45.2609 25.7639C44.1067 25.7639 43.1719 24.8291 43.1719 23.6749C43.1719 22.5208 44.1067 21.5859 45.2609 21.5859C46.4151 21.5859 47.3499 22.5208 47.3499 23.6749Z",
    fill: "#82BB98"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 23.6749C57.7952 24.8291 56.8604 25.7639 55.7062 25.7639C54.552 25.7639 53.6172 24.8291 53.6172 23.6749C53.6172 22.5208 54.552 21.5859 55.7062 21.5859C56.8604 21.5859 57.7952 22.5208 57.7952 23.6749Z",
    fill: "#82BB98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 23.6749C68.9378 24.8291 68.0029 25.7639 66.8488 25.7639C65.6946 25.7639 64.7598 24.8291 64.7598 23.6749C64.7598 22.5208 65.6946 21.5859 66.8488 21.5859C68.0029 21.5859 68.9378 22.5208 68.9378 23.6749Z",
    fill: "#82BB98"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 23.6749C79.3831 24.8291 78.4483 25.7639 77.2941 25.7639C76.1399 25.7639 75.2051 24.8291 75.2051 23.6749C75.2051 22.5208 76.1399 21.5859 77.2941 21.5859C78.4483 21.5859 79.3831 22.5208 79.3831 23.6749Z",
    fill: "#82BB98"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 23.6749C90.5237 24.8291 89.5889 25.7639 88.4347 25.7639C87.2805 25.7639 86.3457 24.8291 86.3457 23.6749C86.3457 22.5208 87.2805 21.5859 88.4347 21.5859C89.5889 21.5859 90.5237 22.5208 90.5237 23.6749Z",
    fill: "#82BB98"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 23.6749C100.969 24.8291 100.034 25.7639 98.88 25.7639C97.7258 25.7639 96.791 24.8291 96.791 23.6749C96.791 22.5208 97.7258 21.5859 98.88 21.5859C100.034 21.5859 100.969 22.5208 100.969 23.6749Z",
    fill: "#82BB98"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 23.6749C111.414 24.8291 110.48 25.7639 109.325 25.7639C108.171 25.7639 107.236 24.8291 107.236 23.6749C107.236 22.5208 108.171 21.5859 109.325 21.5859C110.48 21.5859 111.414 22.5208 111.414 23.6749Z",
    fill: "#82BB98"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 23.6749C122.555 24.8291 121.62 25.7639 120.466 25.7639C119.312 25.7639 118.377 24.8291 118.377 23.6749C118.377 22.5208 119.312 21.5859 120.466 21.5859C121.62 21.5859 122.555 22.5208 122.555 23.6749Z",
    fill: "#82BB98"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 34.1203C4.17801 35.2744 3.24318 36.2093 2.08901 36.2093C0.93483 36.2093 0 35.2744 0 34.1203C0 32.9661 0.93483 32.0312 2.08901 32.0312C3.24318 32.0312 4.17801 32.9661 4.17801 34.1203Z",
    fill: "#82BB98"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 34.1203C15.3186 35.2744 14.3838 36.2093 13.2296 36.2093C12.0755 36.2093 11.1406 35.2744 11.1406 34.1203C11.1406 32.9661 12.0755 32.0312 13.2296 32.0312C14.3838 32.0312 15.3186 32.9661 15.3186 34.1203Z",
    fill: "#82BB98"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 34.1203C25.7639 35.2744 24.8291 36.2093 23.6749 36.2093C22.5208 36.2093 21.5859 35.2744 21.5859 34.1203C21.5859 32.9661 22.5208 32.0312 23.6749 32.0312C24.8291 32.0312 25.7639 32.9661 25.7639 34.1203Z",
    fill: "#82BB98"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 34.1203C36.2093 35.2744 35.2744 36.2093 34.1203 36.2093C32.9661 36.2093 32.0312 35.2744 32.0312 34.1203C32.0312 32.9661 32.9661 32.0312 34.1203 32.0312C35.2744 32.0312 36.2093 32.9661 36.2093 34.1203Z",
    fill: "#82BB98"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 34.1203C47.3499 35.2744 46.4151 36.2093 45.2609 36.2093C44.1067 36.2093 43.1719 35.2744 43.1719 34.1203C43.1719 32.9661 44.1067 32.0312 45.2609 32.0312C46.4151 32.0312 47.3499 32.9661 47.3499 34.1203Z",
    fill: "#82BB98"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 34.1203C57.7952 35.2744 56.8604 36.2093 55.7062 36.2093C54.552 36.2093 53.6172 35.2744 53.6172 34.1203C53.6172 32.9661 54.552 32.0312 55.7062 32.0312C56.8604 32.0312 57.7952 32.9661 57.7952 34.1203Z",
    fill: "#82BB98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 34.1203C68.9378 35.2744 68.0029 36.2093 66.8488 36.2093C65.6946 36.2093 64.7598 35.2744 64.7598 34.1203C64.7598 32.9661 65.6946 32.0312 66.8488 32.0312C68.0029 32.0312 68.9378 32.9661 68.9378 34.1203Z",
    fill: "#82BB98"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 34.1203C79.3811 35.2744 78.4463 36.2093 77.2921 36.2093C76.138 36.2093 75.2031 35.2744 75.2031 34.1203C75.2031 32.9661 76.138 32.0312 77.2921 32.0312C78.4463 32.0312 79.3811 32.9661 79.3811 34.1203Z",
    fill: "#82BB98"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 34.1203C90.5237 35.2744 89.5889 36.2093 88.4347 36.2093C87.2805 36.2093 86.3457 35.2744 86.3457 34.1203C86.3457 32.9661 87.2805 32.0312 88.4347 32.0312C89.5889 32.0312 90.5237 32.9661 90.5237 34.1203Z",
    fill: "#82BB98"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 34.1203C100.969 35.2744 100.034 36.2093 98.88 36.2093C97.7258 36.2093 96.791 35.2744 96.791 34.1203C96.791 32.9661 97.7258 32.0312 98.88 32.0312C100.034 32.0312 100.969 32.9661 100.969 34.1203Z",
    fill: "#82BB98"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 34.1203C111.414 35.2744 110.48 36.2093 109.325 36.2093C108.171 36.2093 107.236 35.2744 107.236 34.1203C107.236 32.9661 108.171 32.0312 109.325 32.0312C110.48 32.0312 111.414 32.9661 111.414 34.1203Z",
    fill: "#82BB98"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 34.1203C122.555 35.2744 121.62 36.2093 120.466 36.2093C119.312 36.2093 118.377 35.2744 118.377 34.1203C118.377 32.9661 119.312 32.0312 120.466 32.0312C121.62 32.0312 122.555 32.9661 122.555 34.1203Z",
    fill: "#82BB98"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 45.2618C4.17801 46.416 3.24318 47.3508 2.08901 47.3508C0.93483 47.3508 0 46.416 0 45.2618C0 44.1076 0.93483 43.1728 2.08901 43.1728C3.24318 43.1728 4.17801 44.1076 4.17801 45.2618Z",
    fill: "#82BB98"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 45.2619C15.3186 46.416 14.3838 47.3509 13.2296 47.3509C12.0755 47.3509 11.1406 46.416 11.1406 45.2619C11.1406 44.1077 12.0755 43.1729 13.2296 43.1729C14.3838 43.1729 15.3186 44.1077 15.3186 45.2619Z",
    fill: "#82BB98"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 45.2619C25.7639 46.416 24.8291 47.3509 23.6749 47.3509C22.5208 47.3509 21.5859 46.416 21.5859 45.2619C21.5859 44.1077 22.5208 43.1729 23.6749 43.1729C24.8291 43.1729 25.7639 44.1077 25.7639 45.2619Z",
    fill: "#82BB98"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 45.2619C36.2093 46.416 35.2744 47.3509 34.1203 47.3509C32.9661 47.3509 32.0312 46.416 32.0312 45.2619C32.0312 44.1077 32.9661 43.1729 34.1203 43.1729C35.2744 43.1729 36.2093 44.1077 36.2093 45.2619Z",
    fill: "#82BB98"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 45.2619C47.3499 46.416 46.4151 47.3509 45.2609 47.3509C44.1067 47.3509 43.1719 46.416 43.1719 45.2619C43.1719 44.1077 44.1067 43.1729 45.2609 43.1729C46.4151 43.1729 47.3499 44.1077 47.3499 45.2619Z",
    fill: "#82BB98"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 45.2619C57.7952 46.416 56.8604 47.3509 55.7062 47.3509C54.552 47.3509 53.6172 46.416 53.6172 45.2619C53.6172 44.1077 54.552 43.1729 55.7062 43.1729C56.8604 43.1729 57.7952 44.1077 57.7952 45.2619Z",
    fill: "#82BB98"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 45.2619C68.9378 46.416 68.0029 47.3509 66.8488 47.3509C65.6946 47.3509 64.7598 46.416 64.7598 45.2619C64.7598 44.1077 65.6946 43.1729 66.8488 43.1729C68.0029 43.1729 68.9378 44.1077 68.9378 45.2619Z",
    fill: "#82BB98"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 45.2619C79.3831 46.416 78.4483 47.3509 77.2941 47.3509C76.1399 47.3509 75.2051 46.416 75.2051 45.2619C75.2051 44.1077 76.1399 43.1729 77.2941 43.1729C78.4483 43.1729 79.3831 44.1077 79.3831 45.2619Z",
    fill: "#82BB98"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 45.2619C90.5237 46.416 89.5889 47.3509 88.4347 47.3509C87.2805 47.3509 86.3457 46.416 86.3457 45.2619C86.3457 44.1077 87.2805 43.1729 88.4347 43.1729C89.5889 43.1729 90.5237 44.1077 90.5237 45.2619Z",
    fill: "#82BB98"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 45.2619C100.969 46.416 100.034 47.3509 98.88 47.3509C97.7258 47.3509 96.791 46.416 96.791 45.2619C96.791 44.1077 97.7258 43.1729 98.88 43.1729C100.034 43.1729 100.969 44.1077 100.969 45.2619Z",
    fill: "#82BB98"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 45.2619C111.414 46.416 110.48 47.3509 109.325 47.3509C108.171 47.3509 107.236 46.416 107.236 45.2619C107.236 44.1077 108.171 43.1729 109.325 43.1729C110.48 43.1729 111.414 44.1077 111.414 45.2619Z",
    fill: "#82BB98"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 45.2618C122.555 46.416 121.62 47.3508 120.466 47.3508C119.312 47.3508 118.377 46.416 118.377 45.2618C118.377 44.1076 119.312 43.1728 120.466 43.1728C121.62 43.1728 122.555 44.1076 122.555 45.2618Z",
    fill: "#82BB98"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 55.7062C4.17801 56.8604 3.24318 57.7952 2.08901 57.7952C0.93483 57.7952 0 56.8604 0 55.7062C0 54.552 0.93483 53.6172 2.08901 53.6172C3.24318 53.6172 4.17801 54.552 4.17801 55.7062Z",
    fill: "#82BB98"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 55.7062C15.3186 56.8604 14.3838 57.7952 13.2296 57.7952C12.0755 57.7952 11.1406 56.8604 11.1406 55.7062C11.1406 54.552 12.0755 53.6172 13.2296 53.6172C14.3838 53.6172 15.3186 54.552 15.3186 55.7062Z",
    fill: "#82BB98"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 55.7062C25.7639 56.8604 24.8291 57.7952 23.6749 57.7952C22.5208 57.7952 21.5859 56.8604 21.5859 55.7062C21.5859 54.552 22.5208 53.6172 23.6749 53.6172C24.8291 53.6172 25.7639 54.552 25.7639 55.7062Z",
    fill: "#82BB98"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 55.7062C36.2093 56.8604 35.2744 57.7952 34.1203 57.7952C32.9661 57.7952 32.0312 56.8604 32.0312 55.7062C32.0312 54.552 32.9661 53.6172 34.1203 53.6172C35.2744 53.6172 36.2093 54.552 36.2093 55.7062Z",
    fill: "#82BB98"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 55.7062C47.3499 56.8604 46.4151 57.7952 45.2609 57.7952C44.1067 57.7952 43.1719 56.8604 43.1719 55.7062C43.1719 54.552 44.1067 53.6172 45.2609 53.6172C46.4151 53.6172 47.3499 54.552 47.3499 55.7062Z",
    fill: "#82BB98"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 55.7062C57.7952 56.8604 56.8604 57.7952 55.7062 57.7952C54.552 57.7952 53.6172 56.8604 53.6172 55.7062C53.6172 54.552 54.552 53.6172 55.7062 53.6172C56.8604 53.6172 57.7952 54.552 57.7952 55.7062Z",
    fill: "#82BB98"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 55.7062C68.9378 56.8604 68.0029 57.7952 66.8488 57.7952C65.6946 57.7952 64.7598 56.8604 64.7598 55.7062C64.7598 54.552 65.6946 53.6172 66.8488 53.6172C68.0029 53.6172 68.9378 54.552 68.9378 55.7062Z",
    fill: "#82BB98"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 55.7062C79.3811 56.8604 78.4463 57.7952 77.2921 57.7952C76.138 57.7952 75.2031 56.8604 75.2031 55.7062C75.2031 54.552 76.138 53.6172 77.2921 53.6172C78.4463 53.6172 79.3811 54.552 79.3811 55.7062Z",
    fill: "#82BB98"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 55.7062C90.5237 56.8604 89.5889 57.7952 88.4347 57.7952C87.2805 57.7952 86.3457 56.8604 86.3457 55.7062C86.3457 54.552 87.2805 53.6172 88.4347 53.6172C89.5889 53.6172 90.5237 54.552 90.5237 55.7062Z",
    fill: "#82BB98"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 55.7062C100.969 56.8604 100.034 57.7952 98.88 57.7952C97.7258 57.7952 96.791 56.8604 96.791 55.7062C96.791 54.552 97.7258 53.6172 98.88 53.6172C100.034 53.6172 100.969 54.552 100.969 55.7062Z",
    fill: "#82BB98"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 55.7062C111.414 56.8604 110.48 57.7952 109.325 57.7952C108.171 57.7952 107.236 56.8604 107.236 55.7062C107.236 54.552 108.171 53.6172 109.325 53.6172C110.48 53.6172 111.414 54.552 111.414 55.7062Z",
    fill: "#82BB98"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 55.7062C122.555 56.8604 121.62 57.7952 120.466 57.7952C119.312 57.7952 118.377 56.8604 118.377 55.7062C118.377 54.552 119.312 53.6172 120.466 53.6172C121.62 53.6172 122.555 54.552 122.555 55.7062Z",
    fill: "#82BB98"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 66.8488C4.17801 68.0029 3.24318 68.9378 2.08901 68.9378C0.93483 68.9378 0 68.0029 0 66.8488C0 65.6946 0.93483 64.7598 2.08901 64.7598C3.24318 64.7598 4.17801 65.6946 4.17801 66.8488Z",
    fill: "#82BB98"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 66.8488C15.3186 68.0029 14.3838 68.9378 13.2296 68.9378C12.0755 68.9378 11.1406 68.0029 11.1406 66.8488C11.1406 65.6946 12.0755 64.7598 13.2296 64.7598C14.3838 64.7598 15.3186 65.6946 15.3186 66.8488Z",
    fill: "#82BB98"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 66.8488C25.7639 68.0029 24.8291 68.9378 23.6749 68.9378C22.5208 68.9378 21.5859 68.0029 21.5859 66.8488C21.5859 65.6946 22.5208 64.7598 23.6749 64.7598C24.8291 64.7598 25.7639 65.6946 25.7639 66.8488Z",
    fill: "#82BB98"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 66.8488C36.2093 68.0029 35.2744 68.9378 34.1203 68.9378C32.9661 68.9378 32.0312 68.0029 32.0312 66.8488C32.0312 65.6946 32.9661 64.7598 34.1203 64.7598C35.2744 64.7598 36.2093 65.6946 36.2093 66.8488Z",
    fill: "#82BB98"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 66.8488C47.3499 68.0029 46.4151 68.9378 45.2609 68.9378C44.1067 68.9378 43.1719 68.0029 43.1719 66.8488C43.1719 65.6946 44.1067 64.7598 45.2609 64.7598C46.4151 64.7598 47.3499 65.6946 47.3499 66.8488Z",
    fill: "#82BB98"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 66.8488C57.7952 68.0029 56.8604 68.9378 55.7062 68.9378C54.552 68.9378 53.6172 68.0029 53.6172 66.8488C53.6172 65.6946 54.552 64.7598 55.7062 64.7598C56.8604 64.7598 57.7952 65.6946 57.7952 66.8488Z",
    fill: "#82BB98"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 66.8488C68.9378 68.0029 68.0029 68.9378 66.8488 68.9378C65.6946 68.9378 64.7598 68.0029 64.7598 66.8488C64.7598 65.6946 65.6946 64.7598 66.8488 64.7598C68.0029 64.7598 68.9378 65.6946 68.9378 66.8488Z",
    fill: "#82BB98"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 66.8488C79.3811 68.0029 78.4463 68.9378 77.2921 68.9378C76.138 68.9378 75.2031 68.0029 75.2031 66.8488C75.2031 65.6946 76.138 64.7598 77.2921 64.7598C78.4463 64.7598 79.3811 65.6946 79.3811 66.8488Z",
    fill: "#82BB98"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 66.8488C90.5237 68.0029 89.5889 68.9378 88.4347 68.9378C87.2805 68.9378 86.3457 68.0029 86.3457 66.8488C86.3457 65.6946 87.2805 64.7598 88.4347 64.7598C89.5889 64.7598 90.5237 65.6946 90.5237 66.8488Z",
    fill: "#82BB98"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 66.8488C100.969 68.0029 100.034 68.9378 98.88 68.9378C97.7258 68.9378 96.791 68.0029 96.791 66.8488C96.791 65.6946 97.7258 64.7598 98.88 64.7598C100.034 64.7598 100.969 65.6946 100.969 66.8488Z",
    fill: "#82BB98"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 66.8488C111.414 68.0029 110.48 68.9378 109.325 68.9378C108.171 68.9378 107.236 68.0029 107.236 66.8488C107.236 65.6946 108.171 64.7598 109.325 64.7598C110.48 64.7598 111.414 65.6946 111.414 66.8488Z",
    fill: "#82BB98"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 66.8488C122.555 68.0029 121.62 68.9378 120.466 68.9378C119.312 68.9378 118.377 68.0029 118.377 66.8488C118.377 65.6946 119.312 64.7598 120.466 64.7598C121.62 64.7598 122.555 65.6946 122.555 66.8488Z",
    fill: "#82BB98"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 77.2932C4.17801 78.4473 3.24318 79.3822 2.08901 79.3822C0.93483 79.3822 0 78.4473 0 77.2932C0 76.139 0.93483 75.2042 2.08901 75.2042C3.24318 75.2042 4.17801 76.139 4.17801 77.2932Z",
    fill: "#82BB98"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 77.2931C15.3186 78.4473 14.3838 79.3821 13.2296 79.3821C12.0755 79.3821 11.1406 78.4473 11.1406 77.2931C11.1406 76.1389 12.0755 75.2041 13.2296 75.2041C14.3838 75.2041 15.3186 76.1389 15.3186 77.2931Z",
    fill: "#82BB98"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 77.2931C25.7639 78.4473 24.8291 79.3821 23.6749 79.3821C22.5208 79.3821 21.5859 78.4473 21.5859 77.2931C21.5859 76.1389 22.5208 75.2041 23.6749 75.2041C24.8291 75.2041 25.7639 76.1389 25.7639 77.2931Z",
    fill: "#82BB98"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 77.2931C36.2093 78.4473 35.2744 79.3821 34.1203 79.3821C32.9661 79.3821 32.0312 78.4473 32.0312 77.2931C32.0312 76.1389 32.9661 75.2041 34.1203 75.2041C35.2744 75.2041 36.2093 76.1389 36.2093 77.2931Z",
    fill: "#82BB98"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 77.2931C47.3499 78.4473 46.4151 79.3821 45.2609 79.3821C44.1067 79.3821 43.1719 78.4473 43.1719 77.2931C43.1719 76.1389 44.1067 75.2041 45.2609 75.2041C46.4151 75.2041 47.3499 76.1389 47.3499 77.2931Z",
    fill: "#82BB98"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 77.2931C57.7952 78.4473 56.8604 79.3821 55.7062 79.3821C54.552 79.3821 53.6172 78.4473 53.6172 77.2931C53.6172 76.1389 54.552 75.2041 55.7062 75.2041C56.8604 75.2041 57.7952 76.1389 57.7952 77.2931Z",
    fill: "#82BB98"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 77.2931C68.9378 78.4473 68.0029 79.3821 66.8488 79.3821C65.6946 79.3821 64.7598 78.4473 64.7598 77.2931C64.7598 76.1389 65.6946 75.2041 66.8488 75.2041C68.0029 75.2041 68.9378 76.1389 68.9378 77.2931Z",
    fill: "#82BB98"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 77.2931C79.3831 78.4473 78.4483 79.3821 77.2941 79.3821C76.1399 79.3821 75.2051 78.4473 75.2051 77.2931C75.2051 76.1389 76.1399 75.2041 77.2941 75.2041C78.4483 75.2041 79.3831 76.1389 79.3831 77.2931Z",
    fill: "#82BB98"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 77.2931C90.5237 78.4473 89.5889 79.3821 88.4347 79.3821C87.2805 79.3821 86.3457 78.4473 86.3457 77.2931C86.3457 76.1389 87.2805 75.2041 88.4347 75.2041C89.5889 75.2041 90.5237 76.1389 90.5237 77.2931Z",
    fill: "#82BB98"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 77.2931C100.969 78.4473 100.034 79.3821 98.88 79.3821C97.7258 79.3821 96.791 78.4473 96.791 77.2931C96.791 76.1389 97.7258 75.2041 98.88 75.2041C100.034 75.2041 100.969 76.1389 100.969 77.2931Z",
    fill: "#82BB98"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 77.2931C111.414 78.4473 110.48 79.3821 109.325 79.3821C108.171 79.3821 107.236 78.4473 107.236 77.2931C107.236 76.1389 108.171 75.2041 109.325 75.2041C110.48 75.2041 111.414 76.1389 111.414 77.2931Z",
    fill: "#82BB98"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 77.2932C122.555 78.4473 121.62 79.3822 120.466 79.3822C119.312 79.3822 118.377 78.4473 118.377 77.2932C118.377 76.139 119.312 75.2042 120.466 75.2042C121.62 75.2042 122.555 76.139 122.555 77.2932Z",
    fill: "#82BB98"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 87.7384C4.17801 88.8926 3.24318 89.8274 2.08901 89.8274C0.93483 89.8274 0 88.8926 0 87.7384C0 86.5842 0.93483 85.6494 2.08901 85.6494C3.24318 85.6494 4.17801 86.5842 4.17801 87.7384Z",
    fill: "#82BB98"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 87.7384C15.3186 88.8926 14.3838 89.8274 13.2296 89.8274C12.0755 89.8274 11.1406 88.8926 11.1406 87.7384C11.1406 86.5842 12.0755 85.6494 13.2296 85.6494C14.3838 85.6494 15.3186 86.5842 15.3186 87.7384Z",
    fill: "#82BB98"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 87.7384C25.7639 88.8926 24.8291 89.8274 23.6749 89.8274C22.5208 89.8274 21.5859 88.8926 21.5859 87.7384C21.5859 86.5842 22.5208 85.6494 23.6749 85.6494C24.8291 85.6494 25.7639 86.5842 25.7639 87.7384Z",
    fill: "#82BB98"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 87.7384C36.2093 88.8926 35.2744 89.8274 34.1203 89.8274C32.9661 89.8274 32.0312 88.8926 32.0312 87.7384C32.0312 86.5842 32.9661 85.6494 34.1203 85.6494C35.2744 85.6494 36.2093 86.5842 36.2093 87.7384Z",
    fill: "#82BB98"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 87.7384C47.3499 88.8926 46.4151 89.8274 45.2609 89.8274C44.1067 89.8274 43.1719 88.8926 43.1719 87.7384C43.1719 86.5842 44.1067 85.6494 45.2609 85.6494C46.4151 85.6494 47.3499 86.5842 47.3499 87.7384Z",
    fill: "#82BB98"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 87.7384C57.7952 88.8926 56.8604 89.8274 55.7062 89.8274C54.552 89.8274 53.6172 88.8926 53.6172 87.7384C53.6172 86.5842 54.552 85.6494 55.7062 85.6494C56.8604 85.6494 57.7952 86.5842 57.7952 87.7384Z",
    fill: "#82BB98"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 87.7384C68.9378 88.8926 68.0029 89.8274 66.8488 89.8274C65.6946 89.8274 64.7598 88.8926 64.7598 87.7384C64.7598 86.5842 65.6946 85.6494 66.8488 85.6494C68.0029 85.6494 68.9378 86.5842 68.9378 87.7384Z",
    fill: "#82BB98"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 87.7384C79.3811 88.8926 78.4463 89.8274 77.2921 89.8274C76.138 89.8274 75.2031 88.8926 75.2031 87.7384C75.2031 86.5842 76.138 85.6494 77.2921 85.6494C78.4463 85.6494 79.3811 86.5842 79.3811 87.7384Z",
    fill: "#82BB98"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 87.7384C90.5237 88.8926 89.5889 89.8274 88.4347 89.8274C87.2805 89.8274 86.3457 88.8926 86.3457 87.7384C86.3457 86.5842 87.2805 85.6494 88.4347 85.6494C89.5889 85.6494 90.5237 86.5842 90.5237 87.7384Z",
    fill: "#82BB98"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 87.7384C100.969 88.8926 100.034 89.8274 98.88 89.8274C97.7258 89.8274 96.791 88.8926 96.791 87.7384C96.791 86.5842 97.7258 85.6494 98.88 85.6494C100.034 85.6494 100.969 86.5842 100.969 87.7384Z",
    fill: "#82BB98"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 87.7384C111.414 88.8926 110.48 89.8274 109.325 89.8274C108.171 89.8274 107.236 88.8926 107.236 87.7384C107.236 86.5842 108.171 85.6494 109.325 85.6494C110.48 85.6494 111.414 86.5842 111.414 87.7384Z",
    fill: "#82BB98"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 87.7384C122.555 88.8926 121.62 89.8274 120.466 89.8274C119.312 89.8274 118.377 88.8926 118.377 87.7384C118.377 86.5842 119.312 85.6494 120.466 85.6494C121.62 85.6494 122.555 86.5842 122.555 87.7384Z",
    fill: "#82BB98"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 98.88C4.17801 100.034 3.24318 100.969 2.08901 100.969C0.93483 100.969 0 100.034 0 98.88C0 97.7258 0.93483 96.791 2.08901 96.791C3.24318 96.791 4.17801 97.7258 4.17801 98.88Z",
    fill: "#82BB98"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 98.88C15.3186 100.034 14.3838 100.969 13.2296 100.969C12.0755 100.969 11.1406 100.034 11.1406 98.88C11.1406 97.7258 12.0755 96.791 13.2296 96.791C14.3838 96.791 15.3186 97.7258 15.3186 98.88Z",
    fill: "#82BB98"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 98.88C25.7639 100.034 24.8291 100.969 23.6749 100.969C22.5208 100.969 21.5859 100.034 21.5859 98.88C21.5859 97.7258 22.5208 96.791 23.6749 96.791C24.8291 96.791 25.7639 97.7258 25.7639 98.88Z",
    fill: "#82BB98"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 98.88C36.2093 100.034 35.2744 100.969 34.1203 100.969C32.9661 100.969 32.0312 100.034 32.0312 98.88C32.0312 97.7258 32.9661 96.791 34.1203 96.791C35.2744 96.791 36.2093 97.7258 36.2093 98.88Z",
    fill: "#82BB98"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 98.88C47.3499 100.034 46.4151 100.969 45.2609 100.969C44.1067 100.969 43.1719 100.034 43.1719 98.88C43.1719 97.7258 44.1067 96.791 45.2609 96.791C46.4151 96.791 47.3499 97.7258 47.3499 98.88Z",
    fill: "#82BB98"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 98.88C57.7952 100.034 56.8604 100.969 55.7062 100.969C54.552 100.969 53.6172 100.034 53.6172 98.88C53.6172 97.7258 54.552 96.791 55.7062 96.791C56.8604 96.791 57.7952 97.7258 57.7952 98.88Z",
    fill: "#82BB98"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 98.88C68.9378 100.034 68.0029 100.969 66.8488 100.969C65.6946 100.969 64.7598 100.034 64.7598 98.88C64.7598 97.7258 65.6946 96.791 66.8488 96.791C68.0029 96.791 68.9378 97.7258 68.9378 98.88Z",
    fill: "#82BB98"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 98.88C79.3831 100.034 78.4483 100.969 77.2941 100.969C76.1399 100.969 75.2051 100.034 75.2051 98.88C75.2051 97.7258 76.1399 96.791 77.2941 96.791C78.4483 96.791 79.3831 97.7258 79.3831 98.88Z",
    fill: "#82BB98"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 98.88C90.5237 100.034 89.5889 100.969 88.4347 100.969C87.2805 100.969 86.3457 100.034 86.3457 98.88C86.3457 97.7258 87.2805 96.791 88.4347 96.791C89.5889 96.791 90.5237 97.7258 90.5237 98.88Z",
    fill: "#82BB98"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 98.88C100.969 100.034 100.034 100.969 98.88 100.969C97.7258 100.969 96.791 100.034 96.791 98.88C96.791 97.7258 97.7258 96.791 98.88 96.791C100.034 96.791 100.969 97.7258 100.969 98.88Z",
    fill: "#82BB98"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 98.88C111.414 100.034 110.48 100.969 109.325 100.969C108.171 100.969 107.236 100.034 107.236 98.88C107.236 97.7258 108.171 96.791 109.325 96.791C110.48 96.791 111.414 97.7258 111.414 98.88Z",
    fill: "#82BB98"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 98.88C122.555 100.034 121.62 100.969 120.466 100.969C119.312 100.969 118.377 100.034 118.377 98.88C118.377 97.7258 119.312 96.791 120.466 96.791C121.62 96.791 122.555 97.7258 122.555 98.88Z",
    fill: "#82BB98"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 109.325C4.17801 110.48 3.24318 111.414 2.08901 111.414C0.93483 111.414 0 110.48 0 109.325C0 108.171 0.93483 107.236 2.08901 107.236C3.24318 107.236 4.17801 108.171 4.17801 109.325Z",
    fill: "#82BB98"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 109.325C15.3186 110.48 14.3838 111.414 13.2296 111.414C12.0755 111.414 11.1406 110.48 11.1406 109.325C11.1406 108.171 12.0755 107.236 13.2296 107.236C14.3838 107.236 15.3186 108.171 15.3186 109.325Z",
    fill: "#82BB98"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 109.325C25.7639 110.48 24.8291 111.414 23.6749 111.414C22.5208 111.414 21.5859 110.48 21.5859 109.325C21.5859 108.171 22.5208 107.236 23.6749 107.236C24.8291 107.236 25.7639 108.171 25.7639 109.325Z",
    fill: "#82BB98"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 109.325C36.2093 110.48 35.2744 111.414 34.1203 111.414C32.9661 111.414 32.0312 110.48 32.0312 109.325C32.0312 108.171 32.9661 107.236 34.1203 107.236C35.2744 107.236 36.2093 108.171 36.2093 109.325Z",
    fill: "#82BB98"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 109.325C47.3499 110.48 46.4151 111.414 45.2609 111.414C44.1067 111.414 43.1719 110.48 43.1719 109.325C43.1719 108.171 44.1067 107.236 45.2609 107.236C46.4151 107.236 47.3499 108.171 47.3499 109.325Z",
    fill: "#82BB98"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 109.325C57.7952 110.48 56.8604 111.414 55.7062 111.414C54.552 111.414 53.6172 110.48 53.6172 109.325C53.6172 108.171 54.552 107.236 55.7062 107.236C56.8604 107.236 57.7952 108.171 57.7952 109.325Z",
    fill: "#82BB98"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 109.325C68.9378 110.48 68.0029 111.414 66.8488 111.414C65.6946 111.414 64.7598 110.48 64.7598 109.325C64.7598 108.171 65.6946 107.236 66.8488 107.236C68.0029 107.236 68.9378 108.171 68.9378 109.325Z",
    fill: "#82BB98"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 109.325C79.3811 110.48 78.4463 111.414 77.2921 111.414C76.138 111.414 75.2031 110.48 75.2031 109.325C75.2031 108.171 76.138 107.236 77.2921 107.236C78.4463 107.236 79.3811 108.171 79.3811 109.325Z",
    fill: "#82BB98"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 109.325C90.5237 110.48 89.5889 111.414 88.4347 111.414C87.2805 111.414 86.3457 110.48 86.3457 109.325C86.3457 108.171 87.2805 107.236 88.4347 107.236C89.5889 107.236 90.5237 108.171 90.5237 109.325Z",
    fill: "#82BB98"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 109.325C100.969 110.48 100.034 111.414 98.88 111.414C97.7258 111.414 96.791 110.48 96.791 109.325C96.791 108.171 97.7258 107.236 98.88 107.236C100.034 107.236 100.969 108.171 100.969 109.325Z",
    fill: "#82BB98"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 109.325C111.414 110.48 110.48 111.414 109.325 111.414C108.171 111.414 107.236 110.48 107.236 109.325C107.236 108.171 108.171 107.236 109.325 107.236C110.48 107.236 111.414 108.171 111.414 109.325Z",
    fill: "#82BB98"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 109.325C122.555 110.48 121.62 111.414 120.466 111.414C119.312 111.414 118.377 110.48 118.377 109.325C118.377 108.171 119.312 107.236 120.466 107.236C121.62 107.236 122.555 108.171 122.555 109.325Z",
    fill: "#82BB98"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 120.466C4.17801 121.62 3.24318 122.555 2.08901 122.555C0.93483 122.555 0 121.62 0 120.466C0 119.312 0.93483 118.377 2.08901 118.377C3.24318 118.377 4.17801 119.312 4.17801 120.466Z",
    fill: "#82BB98"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 120.466C15.3186 121.62 14.3838 122.555 13.2296 122.555C12.0755 122.555 11.1406 121.62 11.1406 120.466C11.1406 119.312 12.0755 118.377 13.2296 118.377C14.3838 118.377 15.3186 119.312 15.3186 120.466Z",
    fill: "#82BB98"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 120.466C25.7639 121.62 24.8291 122.555 23.6749 122.555C22.5208 122.555 21.5859 121.62 21.5859 120.466C21.5859 119.312 22.5208 118.377 23.6749 118.377C24.8291 118.377 25.7639 119.312 25.7639 120.466Z",
    fill: "#82BB98"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 120.466C36.2093 121.62 35.2744 122.555 34.1203 122.555C32.9661 122.555 32.0312 121.62 32.0312 120.466C32.0312 119.312 32.9661 118.377 34.1203 118.377C35.2744 118.377 36.2093 119.312 36.2093 120.466Z",
    fill: "#82BB98"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 120.466C47.3499 121.62 46.4151 122.555 45.2609 122.555C44.1067 122.555 43.1719 121.62 43.1719 120.466C43.1719 119.312 44.1067 118.377 45.2609 118.377C46.4151 118.377 47.3499 119.312 47.3499 120.466Z",
    fill: "#82BB98"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 120.466C57.7952 121.62 56.8604 122.555 55.7062 122.555C54.552 122.555 53.6172 121.62 53.6172 120.466C53.6172 119.312 54.552 118.377 55.7062 118.377C56.8604 118.377 57.7952 119.312 57.7952 120.466Z",
    fill: "#82BB98"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 120.466C68.9378 121.62 68.0029 122.555 66.8488 122.555C65.6946 122.555 64.7598 121.62 64.7598 120.466C64.7598 119.312 65.6946 118.377 66.8488 118.377C68.0029 118.377 68.9378 119.312 68.9378 120.466Z",
    fill: "#82BB98"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 120.466C79.3831 121.62 78.4483 122.555 77.2941 122.555C76.1399 122.555 75.2051 121.62 75.2051 120.466C75.2051 119.312 76.1399 118.377 77.2941 118.377C78.4483 118.377 79.3831 119.312 79.3831 120.466Z",
    fill: "#82BB98"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 120.466C90.5237 121.62 89.5889 122.555 88.4347 122.555C87.2805 122.555 86.3457 121.62 86.3457 120.466C86.3457 119.312 87.2805 118.377 88.4347 118.377C89.5889 118.377 90.5237 119.312 90.5237 120.466Z",
    fill: "#82BB98"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 120.466C100.969 121.62 100.034 122.555 98.88 122.555C97.7258 122.555 96.791 121.62 96.791 120.466C96.791 119.312 97.7258 118.377 98.88 118.377C100.034 118.377 100.969 119.312 100.969 120.466Z",
    fill: "#82BB98"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 120.466C111.414 121.62 110.48 122.555 109.325 122.555C108.171 122.555 107.236 121.62 107.236 120.466C107.236 119.312 108.171 118.377 109.325 118.377C110.48 118.377 111.414 119.312 111.414 120.466Z",
    fill: "#82BB98"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 120.466C122.555 121.62 121.62 122.555 120.466 122.555C119.312 122.555 118.377 121.62 118.377 120.466C118.377 119.312 119.312 118.377 120.466 118.377C121.62 118.377 122.555 119.312 122.555 120.466Z",
    fill: "#82BB98"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17801 130.911C4.17801 132.065 3.24318 133 2.08901 133C0.93483 133 0 132.065 0 130.911C0 129.757 0.93483 128.822 2.08901 128.822C3.24318 128.822 4.17801 129.757 4.17801 130.911Z",
    fill: "#82BB98"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 130.911C15.3186 132.065 14.3838 133 13.2296 133C12.0755 133 11.1406 132.065 11.1406 130.911C11.1406 129.757 12.0755 128.822 13.2296 128.822C14.3838 128.822 15.3186 129.757 15.3186 130.911Z",
    fill: "#82BB98"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 130.911C25.7639 132.065 24.8291 133 23.6749 133C22.5208 133 21.5859 132.065 21.5859 130.911C21.5859 129.757 22.5208 128.822 23.6749 128.822C24.8291 128.822 25.7639 129.757 25.7639 130.911Z",
    fill: "#82BB98"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 130.911C36.2093 132.065 35.2744 133 34.1203 133C32.9661 133 32.0312 132.065 32.0312 130.911C32.0312 129.757 32.9661 128.822 34.1203 128.822C35.2744 128.822 36.2093 129.757 36.2093 130.911Z",
    fill: "#82BB98"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 130.911C47.3499 132.065 46.4151 133 45.2609 133C44.1067 133 43.1719 132.065 43.1719 130.911C43.1719 129.757 44.1067 128.822 45.2609 128.822C46.4151 128.822 47.3499 129.757 47.3499 130.911Z",
    fill: "#82BB98"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 130.911C57.7952 132.065 56.8604 133 55.7062 133C54.552 133 53.6172 132.065 53.6172 130.911C53.6172 129.757 54.552 128.822 55.7062 128.822C56.8604 128.822 57.7952 129.757 57.7952 130.911Z",
    fill: "#82BB98"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 130.911C68.9378 132.065 68.0029 133 66.8488 133C65.6946 133 64.7598 132.065 64.7598 130.911C64.7598 129.757 65.6946 128.822 66.8488 128.822C68.0029 128.822 68.9378 129.757 68.9378 130.911Z",
    fill: "#82BB98"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3811 130.911C79.3811 132.065 78.4463 133 77.2921 133C76.138 133 75.2031 132.065 75.2031 130.911C75.2031 129.757 76.138 128.822 77.2921 128.822C78.4463 128.822 79.3811 129.757 79.3811 130.911Z",
    fill: "#82BB98"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 130.911C90.5237 132.065 89.5889 133 88.4347 133C87.2805 133 86.3457 132.065 86.3457 130.911C86.3457 129.757 87.2805 128.822 88.4347 128.822C89.5889 128.822 90.5237 129.757 90.5237 130.911Z",
    fill: "#82BB98"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 130.911C100.969 132.065 100.034 133 98.88 133C97.7258 133 96.791 132.065 96.791 130.911C96.791 129.757 97.7258 128.822 98.88 128.822C100.034 128.822 100.969 129.757 100.969 130.911Z",
    fill: "#82BB98"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 130.911C111.414 132.065 110.48 133 109.325 133C108.171 133 107.236 132.065 107.236 130.911C107.236 129.757 108.171 128.822 109.325 128.822C110.48 128.822 111.414 129.757 111.414 130.911Z",
    fill: "#82BB98"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 130.911C122.555 132.065 121.62 133 120.466 133C119.312 133 118.377 132.065 118.377 130.911C118.377 129.757 119.312 128.822 120.466 128.822C121.62 128.822 122.555 129.757 122.555 130.911Z",
    fill: "#82BB98"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3186 2.08901C15.3186 3.24318 14.3838 4.17801 13.2296 4.17801C12.0755 4.17801 11.1406 3.24318 11.1406 2.08901C11.1406 0.93483 12.0755 0 13.2296 0C14.3838 0 15.3186 0.93483 15.3186 2.08901Z",
    fill: "#82BB98"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7639 2.08901C25.7639 3.24318 24.8291 4.17801 23.6749 4.17801C22.5208 4.17801 21.5859 3.24318 21.5859 2.08901C21.5859 0.93483 22.5208 0 23.6749 0C24.8291 0 25.7639 0.93483 25.7639 2.08901Z",
    fill: "#82BB98"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2093 2.08901C36.2093 3.24318 35.2744 4.17801 34.1203 4.17801C32.9661 4.17801 32.0312 3.24318 32.0312 2.08901C32.0312 0.93483 32.9661 0 34.1203 0C35.2744 0 36.2093 0.93483 36.2093 2.08901Z",
    fill: "#82BB98"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3499 2.08901C47.3499 3.24318 46.4151 4.17801 45.2609 4.17801C44.1067 4.17801 43.1719 3.24318 43.1719 2.08901C43.1719 0.93483 44.1067 0 45.2609 0C46.4151 0 47.3499 0.93483 47.3499 2.08901Z",
    fill: "#82BB98"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7952 2.08901C57.7952 3.24318 56.8604 4.17801 55.7062 4.17801C54.552 4.17801 53.6172 3.24318 53.6172 2.08901C53.6172 0.93483 54.552 0 55.7062 0C56.8604 0 57.7952 0.93483 57.7952 2.08901Z",
    fill: "#82BB98"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9378 2.08901C68.9378 3.24318 68.0029 4.17801 66.8488 4.17801C65.6946 4.17801 64.7598 3.24318 64.7598 2.08901C64.7598 0.93483 65.6946 0 66.8488 0C68.0029 0 68.9378 0.93483 68.9378 2.08901Z",
    fill: "#82BB98"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3831 2.08901C79.3831 3.24318 78.4483 4.17801 77.2941 4.17801C76.1399 4.17801 75.2051 3.24318 75.2051 2.08901C75.2051 0.93483 76.1399 0 77.2941 0C78.4483 0 79.3831 0.93483 79.3831 2.08901Z",
    fill: "#82BB98"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5237 2.08901C90.5237 3.24318 89.5889 4.17801 88.4347 4.17801C87.2805 4.17801 86.3457 3.24318 86.3457 2.08901C86.3457 0.93483 87.2805 0 88.4347 0C89.5889 0 90.5237 0.93483 90.5237 2.08901Z",
    fill: "#82BB98"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.969 2.08901C100.969 3.24318 100.034 4.17801 98.88 4.17801C97.7258 4.17801 96.791 3.24318 96.791 2.08901C96.791 0.93483 97.7258 0 98.88 0C100.034 0 100.969 0.93483 100.969 2.08901Z",
    fill: "#82BB98"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.414 2.08901C111.414 3.24318 110.48 4.17801 109.325 4.17801C108.171 4.17801 107.236 3.24318 107.236 2.08901C107.236 0.93483 108.171 0 109.325 0C110.48 0 111.414 0.93483 111.414 2.08901Z",
    fill: "#82BB98"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.555 2.08901C122.555 3.24318 121.62 4.17801 120.466 4.17801C119.312 4.17801 118.377 3.24318 118.377 2.08901C118.377 0.93483 119.312 0 120.466 0C121.62 0 122.555 0.93483 122.555 2.08901Z",
    fill: "#82BB98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPattern4);
export default __webpack_public_path__ + "static/media/Dot Pattern 4.72092ca390e71fbca2ee054fad7d7cc1.svg";
export { ForwardRef as ReactComponent };